<template>
  <div class="contribute">
    <!-- 头部 -->
    <div class="head">
      <van-nav-bar :border="false" :title="headTitle" fixed placeholder @click-left="onClickLeft">
        <template #left>
          <van-icon name="arrow-left" size="16" color="#323233" />
        </template>
      </van-nav-bar>
    </div>
    <!-- 不通过理由 -->
    <!-- <div
      class="reason"
      v-if="reasonsForFailure"
      :style="{ color: form.news.isSendBack == 2 ? 'red' : '#9B9A9A' }"
    >
      <van-icon
        name="question-o"
        size="18"
        :color="form.news.isSendBack == 2 ? 'red' : '#9B9A9A'"
      />
      {{ reasonsForFailure }}
    </div> -->
    <div class="reason" v-if="reasonsForFailure" style="color: red">
      <van-icon name="question-o" size="18" color="red" />
      {{ reasonsForFailure }}
    </div>
    <!-- 规则 -->
    <!-- <div class="upload_works_title">
      <van-icon color="#92B3E3" name="warning" style="margin-right: 4px" />{{
        $t('message.activity_upload_works.please')
      }}<span @click="showTouClick" style="cursor: pointer">{{
        $t('message.activity_upload_works.con_rules')
      }}</span
      >{{ $t('message.activity_upload_works.speak') }}；
    </div> -->
    <!-- 影像信息 -->
    <div class="label">
      <div class="line"></div>
      <div class="txt">{{ $t('message.news.personalInformation') }}</div>
    </div>

    <div class="form_box">
      <van-form ref="onlyForm" class="upload_works_flex" label-width="100%">
        <!-- 影像标题 -->
        <div class="label">{{ $t('message.news.authorName') }}<span class="span">*</span></div>
        <van-field
          v-model="form.news.clubOuterName"
          :placeholder="$t('message.news.authorNamePlaceholder')"
          :rules="[{ required: true, message: $t('message.news.authorNamePlaceholder') }]"
          maxlength="30"
          @blur="SensitiveSearch(form.news.clubOuterName)"
        />
      </van-form>
    </div>
    <!-- 影像信息 -->
    <div class="label">
      <div class="line"></div>
      <div class="txt">{{ $t('message.news.newsInformation') }}</div>
    </div>

    <div class="form_box">
      <van-form ref="form" class="upload_works_flex" label-width="100%">
        <!-- 影像标题 -->
        <div class="label">{{ $t('message.news.Headlines') }}<span class="span">*</span></div>
        <van-field
          v-model="form.news.newsTitle"
          :placeholder="$t('message.news.HeadlinesPlaceholder')"
          :rules="[{ required: true, message: $t('message.news.HeadlinesPlaceholder') }]"
          maxlength="30"
          :readonly="readonly"
          @blur="SensitiveSearch(form.news.newsTitle)"
        />

        <!-- 影像描述 -->
        <div class="label" style="margin-bottom: 13px">
          {{ $t('message.news.newsDetails') }}<span class="span">*</span
          ><span class="hint"> {{ $t('message.news.newsDetailsFontSize') }}</span>
        </div>
        <van-field
          v-model="form.news.newsExplain"
          autosize
          type="textarea"
          maxlength="1000"
          :placeholder="$t('message.news.newsDetailsPlaceholder')"
          :rules="[{ required: true, message: $t('message.news.newsDetailsPlaceholder') }]"
          class="textarea"
          :readonly="readonly"
          @blur="SensitiveSearch(form.news.newsExplain)"
        />

        <!-- {{ $t('message.news.filmingLocations')}} -->
        <div class="location_shooting">
          <div class="location_shooting_label">
            <i style="margin-right: 3px" class="iconfont icon-jr-icon-address"></i>
            {{ $t('message.news.filmingLocations') }}
            <span class="span">*</span>
          </div>
          <van-field
            readonly
            clickable
            name="picker"
            :value="form.news.newsProvince"
            :placeholder="$t('message.news.PleaseChooseTheCity')"
            is-link
            :rules="[{ required: true, message: '' }]"
            @click="clickPosition"
            input-align="right"
          />
        </div>
        <van-popup v-model="showPicker" position="bottom">
          <van-area
            @cancel="showPicker = false"
            @confirm="changeAddress"
            :area-list="areaList"
            :columns-num="2"
          />
        </van-popup>

        <!-- 人物标签 -->
        <div class="label">
          <i style="margin-right: 3px" class="iconfont icon-jr-icon-renwuj"></i>
          {{ $t('message.news.characterTag') }}
        </div>
        <van-field
          :readonly="readonly"
          v-model="form.news.figureLabels"
          :placeholder="$t('message.news.characterPlaceholder')"
          @blur="SensitiveSearch(form.news.figureLabels)"
        />

        <!-- 关键词标签 -->
        <div class="label">
          <i style="margin-right: 3px" class="iconfont icon-jr-icon-yoli"></i
          >{{ $t('message.news.keywordTags') }}
        </div>
        <van-field
          :readonly="readonly"
          v-model="form.news.keyword"
          :placeholder="$t('message.news.keywordPlaceholder')"
          @blur="SensitiveSearch(form.news.keyword)"
        />

        <!-- 请输入组图备注 -->
        <div class="label">
          <i style="margin-right: 3px" class="iconfont icon-jr-icon-flag"></i
          >{{ $t('message.news.groupPhotoNotes') }}
        </div>
        <van-field
          :readonly="readonly"
          v-model="form.news.comment"
          :placeholder="$t('message.news.groupPhotoNotesPlaceholder')"
          @blur="SensitiveSearch(form.news.comment)"
        />

        <!-- // 授权到图库赚取收益 -->
        <div class="isAuthorized">
          <div class="isAuthorized_label">
            <i style="margin-right: 3px" class="iconfont icon-jr-icon-dunpai1"></i
            >{{ $t('message.news.authorizeToTheGalleryToEarnRevenue') }}
          </div>
          <van-switch
            @change="switchChange"
            class="isAuthorized_switch"
            v-model="form.news.isAuthorized"
            size="24px"
            :disabled="readonly"
          />
        </div>

        <!-- 上传影像图片 -->
        <div class="label">{{ $t('message.news.pleaseUploadNewsPictures') }}</div>
        <van-field
          class="upload_img"
          name="uploader"
          :rules="[{ required: true, message: $t('message.news.pleaseUploadNewsPictures') }]"
        >
          <template #input>
            <div class="flex">
              <van-uploader
                v-model="imgList"
                :preview-image="false"
                multiple
                :after-read="afterReadNew"
                accept=".jpg,.png"
                :max-size="isOverSize"
                :disabled="readonly"
              />
            </div>
          </template>
        </van-field>
        <!-- <div style="padding: 5px 0" v-if="imgList.length > 0 && rate != 100">
          <van-progress :percentage="rate" />
        </div> -->
        <!-- 图片上传提示 -->
        <div class="img_upload_hint">
          <van-icon name="warning" style="margin-right: 4px" />
          <span>{{ $t('message.news.supportedFormats') }}</span>
        </div>
        <!-- 上传的图片 -->
        <div class="uploader_img_list" v-if="form.subs.length != 0">
          <div
            class="uploader_img_item"
            v-for="(item, index) in form.subs"
            :key="index"
            @click.stop="clickImgIndex(item, index)"
          >
            <van-image
              :class="{ border_blue: imgIndex == index }"
              radius="8"
              width="155"
              height="86"
              :src="'https://imagecharacter.oss-cn-beijing.aliyuncs.com/' + item.works"
            />

            <!-- 默认  未选中的 -->
            <div class="unselected" v-if="item.mainFigure == '0'">
              <div class="close" @click.stop="closeImg(item, index)">
                <van-icon name="cross" color="rgba(0,0,0,1)" />
              </div>
              <div class="unselected_option">
                <div class="circle"></div>
                <div class="txt" @click.stop="setPrimary(item, index)">设为主图</div>
              </div>
            </div>

            <!-- 选中的 -->

            <div class="active_img" v-else @click.stop="clickBack(item, index)">
              <div class="txt">主图</div>
              <div class="correct">
                <van-icon name="success" color="#fff" size="13" />
              </div>
            </div>
          </div>
        </div>
        <div v-if="form.subs.length != 0">
          <div class="label">{{ $t('message.news.categoryDescription') }}</div>
          <van-field
            v-model="form.subs[imgIndex].pointsThat"
            :placeholder="$t('message.news.EditPictureDescription')"
            :readonly="readonly"
            @blur="SensitiveSearch(form.subs[imgIndex].pointsThat)"
          />

          <!-- <div class="label">
            <i style="margin-right: 3px" class="iconfont icon-jr-icon-renwuj"></i
            >{{ $t('message.news.characterTag') }}
          </div>
          <van-field
            v-model="form.subs[imgIndex].figure"
            :placeholder="$t('message.news.characterPlaceholder')"
            :readonly="readonly"
            @blur="SensitiveSearch(form.subs[imgIndex].figure)"
          />

          <div class="label">
            <i style="margin-right: 3px" class="iconfont icon-jr-icon-yoli"></i
            >{{ $t('message.news.keywordTags') }}
          </div>
          <van-field
            v-model="form.subs[imgIndex].keyword"
            :placeholder="$t('message.news.keywordPlaceholder')"
            :readonly="readonly"
            @blur="SensitiveSearch(form.subs[imgIndex].keyword)"
          /> -->
        </div>
      </van-form>
      <!-- 权责说明投稿 -->
      <!-- <div class="p">
        {{ $t('message.activity_upload_works.byagree') }}
        <span @click="responsClickTxt" style="cursor: pointer">
          {{ $t('message.activity_upload_works.sprules') }}</span
        >
      </div> -->
      <!-- <div class="div">
        <van-checkbox icon-size="16px" v-model="checkedAgges"
          ><div class="aggess">
            {{ $t('message.activity_upload_works.myagree')
            }}<span @click="showClickTxt">
              {{ $t('message.activity_upload_works.contribution') }}</span
            >
          </div></van-checkbox
        >
      </div> -->

      <div>
        <van-popup v-model="showTxt" class="text_pop" v-show="false"> </van-popup>
      </div>
    </div>
    <div class="btn">
      <van-button @click="submitBtn" :disabled="display">{{
        $t('message.activity_upload_works.submit')
      }}</van-button>
    </div>
    <!-- 权责说明投稿 -->
    <van-popup v-model="responsShow" class="text_pop"> </van-popup>

    <!-- 投稿协议 -->
    <van-popup v-model="showTou" class="text_pop"> </van-popup>

    <div class="Toast" v-show="submitToast">
      <div class="success"><van-icon name="success" /></div>
      <div class="txt">{{ $t('message.news.submitTip') }}</div>
    </div>
    <!-- 上传图片的loading -->
    <van-overlay :show="showLoading" @click="showLoading = false">
      <van-loading
        type="spinner"
        color="#1989fa"
        style="
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translateX(-50%) translateY(-50%);
        "
      />
    </van-overlay>
    <!-- 
    <div class="fixed" @click="showTouClick">
      <img src="../../../../static/image/fixed-buttom.png" alt="" />
    </div> -->
  </div>
</template>
<script>
import { Toast, Notify } from 'vant'
import { client } from '../../../utils/oss'
import { areaList } from '@vant/area-data'
import { getCookie } from '@/utils/cookie'
import {
  newsSave,
  newsGetNews,
  updateNews,
  queryByIds,
  sensitiveWordAll,
  selectDayNumber
} from '@/api/journalism.js'
export default {
  components: {},
  data() {
    return {
      areaList,
      showLoading: false, //上传图片的loading布尔
      // 提交稿件成功弹窗
      submitToast: false,
      headTitle: this.$t('message.news.albumContribution'),
      // 投稿规则弹框显示隐藏
      showTou: false,
      newsCity: '', // 城市
      newsProvince: '', // 省份
      submitState: false,
      // rate: 0,
      form: {
        news: {
          isExamine: '1',
          apiUserId: 0,
          appId: null,
          clubOuterName: '',
          comment: '',
          createId: 0,
          createTime: '',
          failureReason: '',
          figureLabels: '',
          id: null,
          imageNumber: 0,
          isAuthorized: true,
          isDelete: '',
          isEaveInformation: '',
          isNewsPool: '',
          isRecommend: '',
          isSendBack: '',
          isTop: '',
          keyword: '',
          manuscriptName: '',
          manuscriptStatus: 1,
          manuscriptType: '2',
          newsCity: '',
          newsClassification: '',
          newsCode: '',
          newsExplain: '',
          newsMain: 0,
          newsNation: '中国',
          newsProvince: '',
          newsTitle: '',
          nickName: '',
          organizationId: 0,
          price: 0,
          pricePattern: '',
          rawManuscriptStatus: 0,
          realName: '',
          sendBack: '',
          updateId: 0,
          updateTime: ''
        },
        subs: [
          // {
          //   createTime: '',
          //   facilityInformation: '',
          //   figure: '',
          //   id: 0,
          //   imageHeight: 0,
          //   imageSize: '',
          //   imageWidth: 0,
          //   keyword: '',
          //   mainFigure: '',
          //   newsId: 0,
          //   organizationId: 0,
          //   photographer: '',
          //   pointsThat: '',
          //   shootingTime: '',
          //   videoFormat: '',
          //   videoHeight: '',
          //   videoSize: '',
          //   videoWidth: '',
          //   works: '',
          //   year: ''
          // }
        ]
      },
      imgList: [],
      display: false,
      // 上传不规范图片定时器
      uploadTime: null,
      // 上传图片格式不规范的图片名字
      filesListName: [],
      // 上传图片大小不规范的图片名字
      filesListSize: [],

      // 拍摄地点弹框
      showPicker: false,
      responsShow: false,
      showTxt: false,
      checkedAgges: true,
      imgIndex: 0, // 图片分说明
      readonly: false,
      amend: false, // 修改状态   点击退回的进来这个页面   这个值为true
      subIds: [],
      submitBolList: [false, false]
    }
  },
  computed: {
    index() {
      return this.$route.query.index * 1
    },
    state() {
      return this.$route.query.state
    },
    id() {
      return this.$route.query.id
    },
    reasonsForFailure() {
      let returnVal = ''
      if (this.form.news.isSendBack == 2) {
        returnVal = this.form.news.sendBack
      } else if (this.form.news.manuscriptStatus == 5) {
        returnVal = this.form.news.failureReason
      }
      return returnVal
    }
  },
  watch: {
    submitBolList(val) {
      if (val.every((item, index, arr) => item)) {
        // 正常新增
        if (this.amend == false) {
          this.submitClick()
          // amend为true  则是表示退回的稿件，要进行修改
        } else if (this.amend) {
          this.submitAmend()
        }
      }
    }
  },
  created() {
    queryByIds({ id: getCookie('userId') }).then((res) => {
      console.log(res.data.data.realName, '用户')
      this.form.news.clubOuterName = res.data.data.realName
    })
    // true 是审核不通过的和审核通过  只能查看上传的影像信息
    // false 是退回的稿件  进来后可以进行修改
    if (this.state && this.state == 'true') {
      this.readonly = true
      this.display = true
      this.echo()
    } else if (this.state && this.state == 'false') {
      this.echo()
      this.amend = true
    }
    this.getTitle()
  },
  methods: {
    async SensitiveSearch(val) {
      if (!val) {
        return
      }
      const { data: res } = await sensitiveWordAll({
        pageNum: 1,
        pageSize: 10,
        remark: '',
        searchCriteria: val,
        sensitiveWord: ''
      })
      console.log(res.data.list?.length, 'res')
      if (res.data.list?.length) {
        Toast({
          message: `您输入的${res.data.list
            .map((item) => `"${item.sensitiveWord}"`)
            .join(',')}属于敏感词汇，请重新输入文字`,
          position: 'top'
        })
      }
    },
    // 去除标签
    replace(text) {
      let relStyle = /style\s*?=\s*?([‘"])[\s\S]*?\1/g //去除样式
      let relTag = /<.+?>/g //去除标签
      let relClass = /class\s*?=\s*?([‘"])[\s\S]*?\1/g // 清除类名
      let newHtml = ''
      if (text) {
        newHtml = text.replace(relStyle, '')
        newHtml = newHtml.replace(relTag, '')
        newHtml = newHtml.replace(relClass, '')
      }
      return newHtml
    },
    // 点击详情过来查看回显信息
    async echo() {
      const { data: res } = await newsGetNews({
        id: this.id
      })
      // console.log(res)
      if (res.resultCode == 200) {
        this.form.news = res.data.atlasAndVideoResult
        this.form.news.newsProvince =
          res.data.atlasAndVideoResult.newsProvince + '-' + res.data.atlasAndVideoResult.newsCity
        if (res.data.atlasAndVideoResult.isAuthorized == 1) {
          this.form.news.isAuthorized = false
        } else if (res.data.atlasAndVideoResult.isAuthorized == 2) {
          this.form.news.isAuthorized = true
        }
        this.form.news.newsExplain = this.replace(res.data.atlasAndVideoResult.newsExplain)

        let str = JSON.stringify(res.data.atlasAndVideoResult.subDescriptionNewsAtlasVos)
        this.imgList = JSON.parse(str)
        this.form.subs = res.data.atlasAndVideoResult.subDescriptionNewsAtlasVos
      }
    },
    // 在进入这个页面的时候调用这个方法，来判断是什么类型的
    getTitle() {
      if (this.index === 1) {
        this.headTitle = this.$t('message.explain.txt_xon')
      } else if (this.index === 2) {
        this.headTitle = this.$t('message.news.albumContribution')
      } else if (this.index === 3) {
        this.headTitle = this.$t('message.explain.voide_con')
      } else if (this.index === 4) {
        this.headTitle = this.$t('message.news.newsDetails')
      }
    },
    //点击返回上一页
    onClickLeft() {
      this.$router.go(-1)
    },
    // 投稿规则
    showTouClick() {
      this.showTou = true
    },
    // 提交
    submitBtn() {
      if (this.submitState) {
        return Toast('正在提交中，请勿重复点击')
        // return
      }
      if (this.checkedAgges) {
        this.$refs.form
          .validate()
          .then(() => {
            this.submitBolList.splice(0, 1, true)
            // // 正常新增
            // if (this.amend == false) {
            //   this.submitClick()
            //   // amend为true  则是表示退回的稿件，要进行修改
            // } else if (this.amend) {
            //   this.submitAmend()
            // }
          })
          .catch(() => {
            this.submitBolList.splice(0, 1, false)
            this.$toast.fail(this.$t('message.activity_upload_works.complete'))
          })
        this.$refs.onlyForm
          .validate()
          .then(() => {
            this.submitBolList.splice(1, 1, true)

            // // 正常新增
            // if (this.amend == false) {
            //   this.submitClick()
            //   // amend为true  则是表示退回的稿件，要进行修改
            // } else if (this.amend) {
            //   this.submitAmend()
            // }
          })
          .catch(() => {
            this.submitBolList.splice(1, 1, false)

            this.$toast.fail(this.$t('message.activity_upload_works.complete'))
          })
      } else {
        this.$toast.fail(this.$t('message.activity_upload_works.tick_privacy'))
      }
    },
    async submitAmend() {
      let subDescriptionNewsAtlasVos = []
      this.form.subs.forEach((item, index) => {
        subDescriptionNewsAtlasVos.push({
          figure: item.figure,
          id: item.id,
          keyword: item.keyword,
          mainFigure: item.mainFigure,
          photographer: item.photographer,
          pointsThat: item.pointsThat,
          works: item.works,
          year: item.year
        })
      })
      let isAuthorized = ''
      if (this.form.news.isAuthorized) {
        isAuthorized = '2'
      } else {
        isAuthorized = '1'
      }
      let query = {
        apiUserId: getCookie('userId'),
        clubOuterName: this.form.news.clubOuterName,
        comment: this.form.news.comment,
        figureLabels: this.form.news.figureLabels,
        id: this.id,
        keyword: this.form.news.keyword,
        isAuthorized: isAuthorized,
        newsCity: this.form.news.newsCity,
        newsClassification: this.form.news.newsClassification,
        newsClassifications: this.form.news.newsClassifications,
        newsExplain: this.form.news.newsExplain,
        newsMains: 1,
        newsNation: this.form.news.newsNation,
        newsProvince: this.form.news.newsProvince.split('-')[0],
        newsTitle: this.form.news.newsTitle,
        price: null,
        pricePattern: '',
        subDescriptionNewsAtlasVos: subDescriptionNewsAtlasVos,
        subIds: this.subIds,
        manuscriptStatus: this.readonly ? null : 1
      }

      const { data: res } = await updateNews(query)
      if (res.resultCode == 200) {
        // console.log(res.data)
        Toast('提交成功')
        setTimeout(() => {
          this.$router.go(-1)
        }, 1000)
      }
    },
    async submitClick() {
      if (this.form.news.isAuthorized) {
        this.form.news.isAuthorized = '2'
      } else {
        this.form.news.isAuthorized = '1'
      }

      this.form.news.appId = getCookie('userId')
      const { data: resS } = await queryByIds({
        id: getCookie('userId')
      })
      if (resS.resultCode == 200) {
        this.form.news.nickName = resS.data.nickName
        this.form.news.realName = resS.data.realName
      }

      this.form.news.newsProvince = this.newsProvince
      this.form.news.newsCity = this.newsCity
      this.submitState = true
      const { data: res } = await newsSave(this.form)
      Toast.loading({
        message: '提交中...',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 0
      })
      if (res.resultCode == 200) {
        this.submitToast = true
        this.submitState = false
        Toast.clear()
        let time = setTimeout(() => {
          this.submitToast = false
          clearTimeout(time)
          this.$router.go(-1)
        }, 1500)
        this.form = {
          news: {
            isExamine: '1',
            apiUserId: 0,
            appId: null,
            clubOuterName: '',
            comment: '',
            createId: 0,
            createTime: '',
            failureReason: '',
            figureLabels: '',
            id: null,
            imageNumber: null,
            isAuthorized: '',
            isDelete: '',
            isEaveInformation: '',
            isNewsPool: '',
            isRecommend: '',
            isSendBack: '',
            isTop: '',
            keyword: '',
            manuscriptName: '',
            manuscriptStatus: 1,
            manuscriptType: '2',
            newsCity: '',
            newsClassification: '',
            newsCode: '',
            newsExplain: '',
            newsMain: 0,
            newsNation: '中国',
            newsProvince: '',
            newsTitle: '',
            nickName: '',
            organizationId: 0,
            price: 0,
            pricePattern: '',
            rawManuscriptStatus: 0,
            realName: '',
            sendBack: '',
            updateId: 0,
            updateTime: ''
          },
          subs: [
            // {
            //   createTime: '',
            //   facilityInformation: '',
            //   figure: '',
            //   id: 0,
            //   imageHeight: 0,
            //   imageSize: '',
            //   imageWidth: 0,
            //   keyword: '',
            //   mainFigure: '',
            //   newsId: 0,
            //   organizationId: 0,
            //   photographer: '',
            //   pointsThat: '',
            //   shootingTime: '',
            //   videoFormat: '',
            //   videoHeight: '',
            //   videoSize: '',
            //   videoWidth: '',
            //   works: '',
            //   year: ''
            // }
          ]
        }
      } else {
        this.submitState = false
        Toast('网络繁忙，请稍后重试！')
      }
    },
    clickPosition() {
      if (this.readonly) {
        return
      }
      this.showPicker = true
    },
    initDay() {
      const date = new Date().getTime() // 得到当前时间
      return `-${date}`
    },
    //上传图片
    async afterReadNew(file) {
      this.showLoading = true
      if (file instanceof Array) {
        //  多图
        file.map(async (el) => {
          const { data: result } = await selectDayNumber({ id: 1 })
          let date = new Date()
          let year = date.getFullYear()
          let month = date.getMonth() + 1
          month = month < 10 ? '0' + month : month
          let day = date.getDate()
          day = day < 10 ? '0' + day : day
          // let hours = date.getHours()
          // hours = hours < 10 ? '0' + hours : hours
          // let minutes = date.getMinutes()
          // minutes = minutes < 10 ? '0' + minutes : minutes
          const initDay = '' + year + month + day + result.data
          let t = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
          let a = t.length
          let n = process.env.VUE_APP_UPLOAD_API
          for (let i = 0; i < 10; i++) n += t.charAt(Math.floor(Math.random() * a))
          n = n + '-' + initDay
          let sub = el.file.name.split('.')
          n = n + '.' + sub[sub.length - 1]
          var names = el.file.name.replace(/ +/g, '')
          var name = names.replace(/\+/g, '')
          name = name.replace(/#/g, '-')
          name = name.split('.')[0] + this.initDay() + '.' + name.split('.')[1]
          var getName = process.env.VUE_APP_UPLOAD_API + name
          var fileName = process.env.VUE_APP_UPLOAD_API + name // 文件名称+后缀
          client()
            .multipartUpload(n, el.file)
            .then(async (res) => {
              // console.log(res)
              // console.log(n)
              // const { data: result } = await selectDayNumber({ id: 1 })
              // let date = new Date()
              // let year = date.getFullYear()
              // let month = date.getMonth() + 1
              // let day = date.getDate()
              // const rawImage =
              //   '' + year + month + day + result.data + '.' + el.file.name.split('.')[1]
              const rawImage = initDay + '.' + el.file.name.split('.')[1]

              this.form.subs.push({
                createTime: '',
                facilityInformation: '',
                figure: '',
                id: null,
                imageHeight: 0,
                imageSize: '',
                imageWidth: 0,
                keyword: '',
                mainFigure: '0',
                newsId: 0,
                organizationId: 0,
                photographer: '',
                pointsThat: '',
                shootingTime: '',
                videoFormat: '',
                videoHeight: '',
                videoSize: '',
                videoWidth: '',
                works: n,
                // rawImage: el.file.name,
                rawImage,

                year: ''
              })
              // this.imgList.push(res.res.requestUrls[0])
              this.showLoading = false
            })
            .catch((err) => {
              this.showLoading = false

              // console.log(err)
            })
        })
      } else {
        const { data: result } = await selectDayNumber({ id: 1 })
        let date = new Date()
        let year = date.getFullYear()
        let month = date.getMonth() + 1
        month = month < 10 ? '0' + month : month
        let day = date.getDate()
        day = day < 10 ? '0' + day : day
        // let hours = date.getHours()
        // hours = hours < 10 ? '0' + hours : hours
        // let minutes = date.getMinutes()
        // minutes = minutes < 10 ? '0' + minutes : minutes
        const initDay = '' + year + month + day + result.data
        //  随机得到一个数字大小写字母的字符串
        let t = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
        let a = t.length
        let n = process.env.VUE_APP_UPLOAD_API
        for (let i = 0; i < 10; i++) n += t.charAt(Math.floor(Math.random() * a))
        n = n + '-' + initDay
        let sub = file.file.name.split('.')
        n = n + '.' + sub[sub.length - 1]

        // 单图
        this.rate = 0
        var names = file.file.name.replace(/ +/g, '')
        var name = names.replace(/\+/g, '')
        name = name.replace(/#/g, '-')
        name = name.split('.')[0] + this.initDay() + '.' + name.split('.')[1]
        var getName = process.env.VUE_APP_UPLOAD_API + name
        var fileName = process.env.VUE_APP_UPLOAD_API + name // 文件名称+后缀
        // console.log(n)
        client()
          .multipartUpload(n, file.file)
          .then(async (res) => {
            // console.log(res, 'res上传成功')
            // console.log(n)
            // console.log(file.file.name)
            const { data: result } = await selectDayNumber({ id: 1 })
            let date = new Date()
            let year = date.getFullYear()
            let month = date.getMonth() + 1
            let day = date.getDate()
            // const rawImage =
            //   '' + year + month + day + result.data + '.' + file.file.name.split('.')[1]
            const rawImage = initDay + '.' + file.file.name.split('.')[1]

            if (this.form.subs == [] || this.form.subs.length == 0) {
              this.form.subs.push({
                createTime: '',
                facilityInformation: '',
                figure: '',
                id: 0,
                imageHeight: 0,
                imageSize: '',
                imageWidth: 0,
                keyword: '',
                mainFigure: '1',
                newsId: 0,
                organizationId: 0,
                photographer: '',
                pointsThat: '',
                shootingTime: '',
                videoFormat: '',
                videoHeight: '',
                videoSize: '',
                videoWidth: '',
                works: n,
                rawImage,
                // rawImage: file.file.name,
                year: ''
              })
            } else {
              this.form.subs.push({
                createTime: '',
                facilityInformation: '',
                figure: '',
                id: 0,
                imageHeight: 0,
                imageSize: '',
                imageWidth: 0,
                keyword: '',
                mainFigure: '0',
                newsId: 0,
                organizationId: 0,
                photographer: '',
                pointsThat: '',
                shootingTime: '',
                videoFormat: '',
                videoHeight: '',
                videoSize: '',
                videoWidth: '',
                works: n,
                rawImage,
                // rawImage: file.file.name,
                year: ''
              })
            }
            this.showLoading = false

            // this.imgList.push(res.res.requestUrls[0])
          })
          .catch((err) => {
            // console.log(err)
          })
      }
    },
    // 地区选择
    changeAddress(e) {
      // console.log(e)
      this.form.news.newsProvince = e[0].name + '-' + e[1].name
      this.newsCity = e[1].name
      this.newsProvince = e[0].name
      // newsCity
      this.showPicker = false
    },

    // 上传图片限制
    isOverSize(file) {
      clearTimeout(this.uploadTime)
      this.uploadTime = null
      let re = false
      const imgFormat = /image\/(jpeg|jpg|png)$/
      const type = file.type
      const size = file.size / 1024 / 1024 > 10
      // console.log(file.size)
      // 图片格式判断
      if (!imgFormat.test(type)) {
        this.filesListName.push(file.name + '\n')
        re = true
      }
      // 图片大小判断
      // console.log(size)
      if (size) {
        this.filesListSize.push(file.name + '\n')
        re = true
      }
      // console.log(this.filesListName)
      this.uploadTime = setTimeout(() => {
        this.uploadImgLose()
        this.filesListName = []
        this.filesListSize = []
      }, 100)
      return re
    },
    // 上传不规范图片提示
    uploadImgLose() {
      // 清除定时器
      clearTimeout(this.uploadTime)
      this.uploadTime = null
      // 图片类型
      let filesListNameS = []
      // 图片大小
      let filesListSizeS = []

      filesListNameS = [...new Set(this.filesListName)]
      filesListSizeS = [...new Set(this.filesListSize)]

      if (filesListNameS.length != 0) {
        Toast({
          message: '以下图片格式不正确\n' + filesListNameS.join('')
        })
      }
      if (filesListSizeS.length != 0) {
        Toast({
          message: '以下图片大小不能大于10M\n' + filesListSizeS.join('')
        })
      }
    },
    // 删除图片
    closeImg(item, index) {
      if (this.readonly) {
        return
      }
      // this.imgIndex = index - 1
      if (index != 0) {
        this.imgIndex = index - 1
      } else {
        this.imgIndex = 0
      }
      this.subIds.push(item.id)
      this.form.subs.splice(index, 1)
      this.imgList.splice(index, 1)

      // console.log(this.imgList)
    },
    // 设置为主图
    setPrimary(item, index) {
      if (this.readonly) {
        return
      }
      for (let i = 0; i < this.form.subs.length; i++) {
        if (this.form.subs[i].mainFigure == '1') {
          return Toast('只能选中一张图片设为主图')
        }
      }
      this.form.subs[index].mainFigure = '1'
    },

    clickBack(item, index) {
      this.form.subs[index].mainFigure = '0'
    },
    // 点击切换图片分说明内容
    clickImgIndex(item, index) {
      this.imgIndex = index
      // console.log(index)
    },
    // 打开权责说明弹窗
    responsClickTxt() {
      this.responsShow = true
    },
    showClickTxt() {
      this.showTxt = true
    },
    // 开关
    switchChange(val) {}
  },

  mounted() {}
}
</script>
<style scoped lang="less">
.contribute {
  .border_blue {
    border: 3px solid #3360ff;
  }
  .reason {
    background-color: rgba(53, 98, 255, 0.1);
    width: 100%;
    padding: 11px 19px;
    font-size: 13px;
    box-sizing: border-box;
    color: #9b9a9a;
  }

  .upload_works_title {
    width: 100%;
    overflow: hidden;
    box-sizing: border-box;
    padding: 10px 20px;
    color: #1a1a1a;
    font-size: 12px;
    font-weight: 400;

    i {
      color: #92b3e3;
    }

    span {
      color: #3360ff;
    }
  }
  .label {
    width: 100%;
    height: 22px;
    display: flex;
    align-items: center;
    margin-top: 16px;
    .line {
      width: 4px;
      height: 21px;
      background-color: #3562ff;
      margin-right: 11px;
    }
    .txt {
      color: #263245;
      font-size: 16px;
      font-weight: 500;
    }
  }
  .form_box {
    padding: 0 16px;
    .upload_works_flex {
      width: 100%;
      overflow: hidden;

      /deep/.van-cell {
        padding: 10px 0;
      }
      .van-cell::after {
        width: 100%;
        left: 0;
      }
      .van-cell::before {
        width: 100%;
        left: 0;
        position: absolute;
        box-sizing: border-box;
        content: ' ';
        pointer-events: none;
        right: 16px;
        bottom: 0;
        border-bottom: 1px solid #ebedf0;
        -webkit-transform: scaleY(0.5);
        transform: scaleY(0.5);
      }
      .isAuthorized {
        height: 48px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #efefef;
        .isAuthorized_label {
          font-size: 14px;
          color: #263245;
        }
        // .isAuthorized_switch {
        // }
      }
      .location_shooting {
        display: flex;
        border-bottom: 1px solid #ebedf0;
        height: 50px;
        align-items: center;
        .location_shooting_label {
          width: 100%;
          display: flex;
          align-items: center;
          font-size: 14px;
          color: #1a1a1a;

          .span {
            color: #e34747;
            margin-right: 3px;
          }
        }
        .van-cell {
          padding: 0;
        }
        .van-cell::before {
          border-bottom: 0px solid #fff;
        }
      }
      .textarea {
        padding: 10px 10px !important;
        border: 1px solid #ebedf0;

        /deep/.van-field__control {
          height: 283px !important;
        }
      }

      .label {
        font-size: 14px;
        color: #1a1a1a;

        .span {
          color: #e34747;
          margin-right: 3px;
        }
        .hint {
          font-size: 12px;
          color: #999999;
        }
      }
      .upload_img {
        /deep/.van-icon-photograph:before {
          content: '\e6fa';
        }
      }
      .upload_img::after {
        display: none;
      }
      .upload_img::before {
        display: none;
      }

      .img_upload_hint {
        font-size: 11px;
        color: #999999;
      }
    }

    .uploader_img_list {
      height: 100px;
      overflow-x: auto;
      display: flex;
      margin-top: 16px;
      .uploader_img_item {
        width: 155px;
        height: 86px;
        margin-right: 9px;
        position: relative;

        .unselected {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;

          .close {
            width: 12px;
            height: 12px;
            border-radius: 50%;
            background-color: #fff;
            position: absolute;
            right: 3px;
            top: 5px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 10px;
          }

          .unselected_option {
            position: absolute;
            left: 4px;
            bottom: 6px;
            width: 69px;
            height: 24px;
            border-radius: 19px;
            background-color: #d9d9d9;
            display: flex;
            align-items: center;
            justify-content: center;
            .circle {
              border-radius: 50%;
              width: 14px;
              height: 14px;
              margin-right: 4px;
              background-color: #fff;
            }

            .txt {
              font-size: 10px;
              color: #1a1a1a;
            }
          }
        }

        .active_img {
          border: 2px solid #3562ff;
          border-radius: 4px;
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          padding: 6px;
          box-sizing: border-box;
          display: flex;

          justify-content: space-between;

          .txt {
            width: 36px;
            height: 16px;
            color: #fff;
            font-size: 12px;
            background-color: rgba(53, 98, 255, 0.7);
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 2px;
          }

          .correct {
            width: 16px;
            height: 16px;
            border-radius: 50%;
            background-color: #3562ff;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }
      }
    }
  }
  .btn {
    width: 100%;
    box-sizing: border-box;
    overflow: hidden;
    justify-content: center;
    align-items: center;
    padding: 60px 20px 30px 20px;
    background-color: #fff;
    text-align: center;

    button {
      width: 240px;
      height: 36px;
      line-height: 36px;
      text-align: center;
      padding: 0;
      border: none;
      background: linear-gradient(301.69deg, #6688ff 13.72%, #3360ff 67.35%);
      box-shadow: 0px 0px 12px rgba(255, 192, 21, 0.2);
      color: #fff;
      font-size: 14px;
      font-weight: 400;
      border-radius: 16px;
    }
  }
  .div {
    box-sizing: border-box;
    width: 100%;
    overflow: hidden;
    padding: 10px 0px;
    background-color: #fff;

    .aggess {
      display: flex;
      align-items: center;
      color: #263245;
      font-size: 12px;
      font-weight: 400;

      span {
        color: #3360ff;
      }
    }
  }

  .p {
    font-size: 12px;
    box-sizing: border-box;
    // padding: 20px 16px 10px 16px;
    color: #999999;
    background: #fff;
    font-weight: 400;
    margin-top: 25px;

    span {
      color: #3360ff;
    }
  }
  .text_pop {
    width: 90%;
    height: 80%;
    border-radius: 12px;
  }

  .Toast {
    background-color: rgba(26, 26, 26, 0.4);
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    align-items: center;
    width: 241px;
    height: 70px;
    justify-content: center;
    border-radius: 4px;

    .success {
      width: 20px;
      height: 20px;
      border-radius: 50%;
      margin-right: 5px;
      background-color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .txt {
      font-size: 16px;
      color: #fff;
    }
  }
  .fixed {
    position: fixed;
    right: 10px;
    top: 300px;
    z-index: 99;
    // box-shadow: 0px 0px 12px rgba(255, 192, 21, 0.2);

    img {
      width: 60px;
      height: 60px;
    }
  }
}
</style>
